export default "__VITE_ASSET__eVluj9Qx__"